module.exports = __webpack_public_path__ + "img/red-3-diamond-striped.19109fe9.svg";